import type {
    Charity,
    GetDefaultDraftApiResponse,
    MemberPaymentOption
} from 'tradera/state/services/types/webapi-selling-generated';
import { isServer } from 'tradera/utils/nextjs';

export type SellingJsData = {
    member: MemberData;
    charities: Charity[];
    isCompanyUser: boolean;
    isSwedishUser: boolean;
    defaultDrafts: GetDefaultDraftApiResponse;
    braintree: BraintreeData;
    initialBankIdForBinRequired: boolean;
    bankIdForBinRequired: boolean;
    maskedPersonalNumber: string;
    paymentOptions: MemberPaymentOption[];
    supportsVerification: boolean;
    birthdate: string;
    consent: ConsentData;
    selectedDescriptionLanguageCodeIso2: string;
    shippingFromCountryCodeIso2: string;
    combinedShippingDays: number;
};

export type BraintreeData = {
    isBankAccountNumberProvided: boolean;
    maskedBankAccount: string;
};

export type MemberData = {
    firstName: string;
};

export type ConsentData = {
    hasTraderaPayConsent: boolean;
    isUnderLicense: boolean;
    needsConsentOfTraderaPayAgreement: string;
    signatoryVerificationRequired: boolean;
};

// extend window object with global data
declare global {
    interface Window {
        sellingGlobalData: SellingJsData;
    }
}

export default isServer ? undefined : window.sellingGlobalData;
